import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Sparkles, Maximize2 } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { ChatThread } from "@/components/assistant/ChatThread";

export function QuickAsk() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [cid, setCid] = useState(null);
  if (location.pathname.startsWith("/ask")) return null;

  return (
    <>
      <button onClick={() => setOpen(true)} className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 rounded-full bg-lasso-ink px-5 py-3.5 text-sm font-semibold text-white shadow-[0_12px_32px_rgba(11,11,12,0.25)] transition-transform duration-200 hover:-translate-y-0.5 hover:bg-lasso-navy" data-testid="quick-ask-button">
        <Sparkles className="h-4 w-4 text-lasso-sky" /> Ask Lasso
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="flex w-full flex-col bg-lasso-paper sm:max-w-md" data-testid="quick-ask-panel">
          <SheetHeader className="flex-row items-center justify-between space-y-0 pr-8">
            <SheetTitle className="font-display text-base">Ask Lasso</SheetTitle>
            <div className="flex gap-3 text-xs font-semibold">
              {cid && <button onClick={() => setCid(null)} className="hover:underline" data-testid="quick-ask-new">New chat</button>}
              <Link to={cid ? `/ask/${cid}` : "/ask"} onClick={() => setOpen(false)} className="inline-flex items-center gap-1 hover:underline" data-testid="quick-ask-open-full"><Maximize2 className="h-3 w-3" /> Full view</Link>
            </div>
          </SheetHeader>
          <div className="min-h-0 flex-1 pt-2"><ChatThread key={cid || "new"} conversationId={cid} onCreated={(id) => setCid(id)} compact /></div>
        </SheetContent>
      </Sheet>
    </>
  );
}
